<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn 
          class="mr-1" small color="primary" dark 
          v-on="{...tooltip}"
          v-on:click="() => dialog = !dialog"
        >
          <v-icon>{{`${ (mode === 0) ? 'mdi-plus' : 'mdi-pencil-outline' }`}}</v-icon>
        </v-btn>
      </template>
      <span>{{ `${ (mode === 0) ? $t('referenceBooks.banks.Create') : $t('referenceBooks.banks.Edit')}` }}</span>
    </v-tooltip>
    <DragForm 
      v-model="dialog" 
      
      @close="this.$emit('rerender')"
    >
      <v-card width="800"
      >
        <v-card-title>
          <span
            class="headline"
          >{{ `${ (mode === 0) ? $t('referenceBooks.banks.Create') : $t('referenceBooks.banks.Edit')}` }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentBank.bankName"
                  :label="this.$t('referenceBooks.banks.Name') + '*'"
                  required
                  :error-messages="errorMessage"
                  v-on:blur="onBlur"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentBank.description"
                  :label="this.$t('referenceBooks.banks.Description')"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentBank.alias"
                  :label="this.$t('referenceBooks.banks.Alias') + '*'"
                  required
                  :error-messages="errorMessage"
                  v-on:blur="onBlur"
                />
              </v-col>
            </v-row>
          </v-container>
          <small>*{{$t('referenceBooks.requiredFields')}}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
          <v-btn v-if="mode===0" color="blue darken-1" text @click="createBank">{{$t('Create')}}</v-btn>
          <v-btn v-else color="blue darken-1" text @click="saveBank">{{$t('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import Vue from 'vue';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  components: {
    DragForm,
  },
  name: 'BankDialog',
  props: {
    mode: {
      type: Number,
      defaultItem: 0
    },
    bank: {
      type: Object,
      defaultItem: {
        bankId: 0,
        bankName: '',
        description: '',
      }
    }
  },
  data() {
    return {
      currentBank: {
        bankName: '',
        description: '',
      },
      dialog: false,

      busyValues:{
        'BankName': [],
      },
      wasBlurred: false,
      executeButtonClick: false,
    };
  },
  watch: {
    dialog(flag) {
      if(!flag)
        this.clear();
      else if(this.mode === 1)
        this.loadOne();
      else
        this.loadNull();
    }
  },
  computed: {    
    propertiesResponse() {
      return { 'BankName' : this.$t('referenceBooks.banks.Name') };
    },
    errorMessage() {
      const name = this.currentBank.bankName;
      const check = this.executeButtonClick || 
                    this.wasBlurred ||
                    name != null && name.length != 0;
                    
      if (!check)
        return '';

      return this.checkText(name, 'BankName');
    }
  },
  methods: {
    clear(){      
      this.wasBlurred = false;
      this.executeButtonClick = false;
      this.busyValues = {
        'BankName': [],
      };
      this.currentBank = {
        bankName: '',
        description: ''
      };
    },
    loadOne(){
      if(this.bank!= null){
        Object.assign(this.currentBank, this.bank);
      }
    },
    loadNull(){

    },
    checkText(value, ind = null){
      if (value == null || value.length == 0) 
        return this.$t('validations.notEmpty');

      if(ind != null){
        if(this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    onBlur() {
      this.wasBlurred = true;
    },
    checkFields(){
      let result = true;
      const errors = this.checkText(this.currentBank.bankName, 'BankName');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.banks.Name')}`, errors, 'error');
        result = false;
      }

      return result;
    },
    createBank() {
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      const name = this.currentBank.bankName;
      // Проверка. Валидация
      this.$axios.banks
        .post({
          ...this.currentBank
        })
        .then(response => {
          if (response.status == 200){
            const id = response.data;
            notifySuccess('', this.$t('Messages.BankWasCreated', [this.currentBank.bankName]));
            this.$emit('created', response.status, name, id);
            this.dialog = false;
          }
        })
        .catch(error => {
          notifyError('', this.$t('Messages.ErrorOccuredWhileCreatingBank', [this.currentBank.bankName]));
          this.catchErrors(error);
        });
    },
    catchErrors(error, errorHeader = ''){
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401){
        for(let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      }
      else{
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error){
      console.error(error);
      
      switch(data.errorType){
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value){
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${this.propertiesResponse[property]}`;

      this.showMessage(errorInField, this.$t('errorsMessages.BusyName'), 'error');
    },
    onNoRigths(errorHeader = ''){
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    onUnknownError(error){
      console.error(error);
      
      this.$emit('error', error);
    },
    saveBank() {
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      this.$axios.banks.put(this.currentBank.bankId, this.currentBank)
        .then(response => {
          notifySuccess('', this.$t('Messages.BankWasEdited', [this.currentBank.bankName]));
          this.$emit('saved', response.status, this.currentBank);
          this.dialog = false;
        })
        .catch(error => {
          notifyError('', this.$t('Messages.ErrorOccuredWhileEditingBank', [this.currentBank.bankName]));
          this.catchErrors(error);
        });
    },
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
    getData(){
      this.$axios.banks
        .getById(this.bank.bankId)
        .then(response => response.data)
        .then(json => (this.currentBank = json[0]))
        .catch(error => console.error(error));
    },
  },
};
</script>